export class CloudRegion {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudRegion.attributeTypeMap;
    }
    constructor() {
    }
}
